const TestimoData = [
    {
        img: "/assets/images/kwikpass/heal.png",
        state: "INDIA",
        content: "Great customer service and tech support from Kwikpass team now we are able to do nice process on our store.",
        size: { width: "120px", height: "45px" }  // Custom size
    },
    {
        img: "/assets/images/kwikpass/otrix.png",
        state: "INDIA",
        content: "Kwik Pass is incredibly supportive and always ready to help. Kriti Gautam is an excellent developer with great skills. They make a fantastic team! Also, Kiwi Pass is the best app for seamless login on Shopify.",
        size: { width: "60px", height: "50px" }  // Custom size
    },
    {
        img: "/assets/images/kwikpass/nisarg.png",
        state: "INDIA",
        content: `Using Kwik Pass has been an absolute delight! The app is simple to use and integrates perfectly with my Shopify store. What really stood out to me was their amazing support team—super friendly, quick to respond, and always ready to help whenever I needed it.<br />Overall, it’s been a fantastic experience, and I’d highly recommend Kwik Pass to anyone looking to enhance their Shopify store. Definitely an app worth having!`,
        size: { width: "50px", height: "50px" }  // Custom size
    }
]

export const SectionSix = () => {
    return (
        <div className='section-6'>
            <div className="container-fluid">
                <div className="sec-heading">
                    <h1>Merchant success stories etc</h1>
                </div>
                <p style={{ fontWeight: "100", color: "#FFFFFF60" }} className='mb-4'>What Our Merchants Say: Real Results, Real Growth</p>
                
                <div className="d-flex flex-wrap justify-content-center gap-3 overflow-x-auto">
                    {TestimoData.map((item, index) => (
                        <div key={index} className="Testimo-Cards px-4 py-3 text-white  flex-column">
                            {/* Logo & Country Section */}
                            <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
                                <img
                                    src={item.img}
                                    alt="logo"
                                    className="me-2"
                                    style={{ width: item.size.width, height: item.size.height, objectFit: "contain" }} // Individual sizes
                                />
                                <p style={{ fontWeight: 100, opacity: "0.6", fontSize: '14px', marginTop: '10px' }}>{item.state}</p>
                            </div>
                            
                            {/* Content */}
                            <div className="mt-3 text-start" style={{ fontSize: '14px', textAlign: 'left', lineHeight: "1.5" }}>
                                <span dangerouslySetInnerHTML={{ __html: item.content }} />
                            </div>
                        </div>
                    ))}
                </div>
                 {/* CTA Section */}
                 <div className="last-section-six row d-flex align-items-center justify-content-between pb-0">
                    <div className="view col-lg-8 d-flex align-items-center">
                        <div className="view-img1">
                            <img
                                src="/assets/images/kwikpass/view.png"
                                alt="Customer Engagement"
                                width={170}
                            />
                        </div>
                        <div className="view-text1  mb-3"> {/* Reduced margin */}
                            <h4>Ready to Transform Your Customer Engagement?</h4>
                            <p className="text-wrap">
                            Join the top e-commerce brands leveraging the best and most secure website visitor tracking tools to capture, engage, and convert every visitor. Experience seamless integration and measurable growth.
                            </p>
                        </div>
                    </div>
                    <div className="cta-container1 col-lg-3 text-end mb-3 p-0 ">
                    <button className="cta">Get Started Now</button>
                </div>
                </div>
            </div>
        </div>
    )
}
